import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import ImpersonationBanner from "../components/ImpersonationBanner";
import PreviewBanner from "../components/PreviewBanner";
import { PreviewModeProvider } from "../contexts/PreviewModeContext";
import { SidebarProvider } from "../contexts/SidebarContext";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";

function AppLayout() {
  return (
    <PreviewModeProvider>
      <SidebarProvider>
        <ImpersonationBanner />
        <Box sx={{ display: "flex", height: "100vh" }}>
          <Sidebar />

          {/* Main Content Area */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              minWidth: 0,
            }}
          >
            <Header />
            <PreviewBanner />

            <Box
              id="main-scroll-container"
              sx={{
                flex: 1,
                overflow: "auto",
                backgroundColor: "background.default",
              }}
            >
              <Container
                sx={{
                  px: { xs: 2, sm: 4, md: 8 },
                  py: 6,
                  maxWidth: "none !important",
                }}
              >
                <Outlet />
              </Container>
            </Box>
          </Box>
        </Box>
      </SidebarProvider>
    </PreviewModeProvider>
  );
}

export default AppLayout;
